import { Box } from "@chakra-ui/react";
import React from "react";
import DynamicTable from "../DynamicTable/DynamicTable";

const Deviation = ({ data, headers }) => {
  // console.log("deviation output : ", data);
  return (
    <Box maxW="1150px" m="auto">
      <DynamicTable data={data || []} headers={headers} />
    </Box>
  );
};

export default Deviation;
